import { Progress, Spin } from "antd";
import {
  useLoadingUploadFlow,
  FLOWS,
} from "hook/bailiff/document/flow/useLoadingUploadFlow";
import { useSelector } from "react-redux";
import { bailiffDocumentPercentUploadSelector } from "store/bailiff/bailiff/document/bailiff_document.selector";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const PreviewLoading = ({ audio }) => {
  // -------------------------- VAR -----------------------------
  const { flow } = useLoadingUploadFlow();
  const isFlow = flow === FLOWS.LOADING;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (!isFlow) return null;
  return (
    <div className="flex min-h-[200px] flex-col items-center justify-center">
      {audio === null && <Spin />}
      <div className="text-gray-400">Vui lòng chờ hệ thống xử lý</div>
    </div>
  );
};
export default PreviewLoading;
